import * as INR from "../INR.ts";
import * as FwDatas from "../FwDatas.ts";

import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as Screen from "../lib/Screen.js";
import $ from "../$.js";

export class ControllerBook{
  constructor(NODE_LEFT,TPL_LEFT,NODE_RIGHT,TPL_RIGHT,TPL_RIGHT_EMPTY,freshGetter,onFreshGetted = (a)=>{return {items:a}},microUpdater){
    this.freshGetter = freshGetter;
    var targetId = libLocation.getURLParam("metaId"),rightUpdater;
    if(Screen.isMobileView()){
      rightUpdater = function(showEmpty){
        var target = FwDatas.get(targetId);
        NODE_RIGHT.toggleClass('open',!!targetId)
        if(target){
          Html.setHtml(
            NODE_RIGHT,
            TPL_RIGHT,
            target
          );
        }
      }
    }else{
      rightUpdater = function(showEmpty){
        if(!targetId){
          if(TPL_RIGHT_EMPTY){
            Html.setHtml(NODE_RIGHT,TPL_RIGHT_EMPTY)
          }
        }else{
          Html.setHtml(
            NODE_RIGHT,
            TPL_RIGHT,
            FwDatas.get(targetId)
          );
        }
      }
    }
    
    function highlightSelected(){
      NODE_LEFT.find("[data-fw-onclick='controllerselect']").each(function(idx,node){
        node = $(node);
        node.toggleClass("selected",node.metaId()===targetId);
      });
    }
    
    INR.subscribe("handleParam",()=>{
      targetId = libLocation.getURLParam("metaId");
      highlightSelected();
      rightUpdater();
      
    });
    this.onRefresh = function(allitems){
      Html.setHtml(NODE_LEFT,TPL_LEFT,onFreshGetted(allitems));
      
      if(allitems.length===0){
        targetId = undefined;
      }else{
        if(allitems.find(item=>item.metaId===targetId)===undefined){
          if(Screen.isMobileView()){
            targetId = undefined;
          }else if(Array.isArray(allitems)){
            targetId = allitems[0].metaId;
          }else{
            targetId = allitems.getDefaultItem().metaId;
          }
        }
      } 
      
      highlightSelected();
      rightUpdater();
    }
    freshGetter.need().then(this.onRefresh)
  }
  async refresh(){
     return this.freshGetter.refresh().then(this.onRefresh)
  }
  select(metaId){
    libLocation.goTo('?metaId='+metaId,!Screen.isMobileView());
  }
}

export class SimpleControllerBook{
  constructor(NODE_LEFT,leftUpdater,leftDataCache,NODE_RIGHT,rawRightUpdater){
    var targetId,rightUpdater;
    if(Screen.isMobileView()){
      rightUpdater = function(){
        NODE_RIGHT.toggleClass('open',!!targetId)
        rawRightUpdater(targetId)
      }
    }else{
      rightUpdater = rawRightUpdater
    }
    
    function highlightSelected(){
      NODE_LEFT.find("[data-fw-onclick='controllerselect']").each(function(idx,node){
        node = $(node);
        node.toggleClass("selected",node.metaId()===targetId);
      });
    }
    
    INR.subscribe("handleParam",()=>{
      var newTargetId = libLocation.getURLParam("metaId");
      if(newTargetId!==targetId){
        targetId = newTargetId;
        highlightSelected();
        rightUpdater(targetId);
      }
      
    });
    this.onRefresh = async function(allitems){
      await leftUpdater(allitems);
      if(allitems.length===0){
        targetId = undefined;
      }else{
        if(allitems.find(item=>item.metaId===targetId)===undefined){
          if(Screen.isMobileView()){
            targetId = undefined;
          }else if(Array.isArray(allitems)){
            targetId = allitems[0].metaId;
          }else{
            targetId = allitems.getDefaultItem().metaId;
          }
        }
      } 
      
      highlightSelected();
      await rightUpdater(targetId);
    }
    this.select = (metaId)=>{
      libLocation.goTo('?metaId='+metaId,!Screen.isMobileView());
    }
    this.refresh = async ()=>{
      this.onRefresh(await leftDataCache.refresh())
    }
    leftDataCache.need().then(this.onRefresh)
  }
  
}



Html.register({
  controllerselect:function(){
    libLocation.goTo('?metaId='+this.metaId(),!Screen.isMobileView());
  }
})